module.exports = __webpack_public_path__ + "static/vegetace3-db593c1107b6eaf005c4a1ce5f14b368.jpg";